/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OperatorVcdsDeploymentCloudProvider } from './operatorVcdsDeploymentCloudProvider';
import { OperatorVcdsDeploymentNetwork } from './operatorVcdsDeploymentNetwork';
import { VcdsDeploymentVersion } from './vcdsDeploymentVersion';


export interface OperatorVcdsDeploymentAttributes { 
    cloud_provider?: OperatorVcdsDeploymentCloudProvider;
    network?: OperatorVcdsDeploymentNetwork;
    version?: VcdsDeploymentVersion;
}

